import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts'
import { ChartContainer, ChartTooltip, type ChartConfig } from '@/shared/components/ui/chart'
import type { BreakdownGrupo } from '../types'

const chartConfig = {
  registros: { label: 'Registros', color: '#7c3aed' },
  participantes: { label: 'Participantes', color: '#16a34a' },
} satisfies ChartConfig

function ConversionTooltip({ active, payload }: { active?: boolean; payload?: { payload: BreakdownGrupo }[] }) {
  if (!active || !payload?.length) return null
  const d = payload[0].payload
  return (
    <div className="rounded-lg border bg-background px-3 py-2 text-xs shadow-md">
      <div className="mb-1 font-medium">{d.grupo}</div>
      <div className="flex items-center justify-between gap-6">
        <span className="text-muted-foreground">Registros</span>
        <span className="font-semibold text-violet-600">{d.registros.toLocaleString()}</span>
      </div>
      <div className="flex items-center justify-between gap-6">
        <span className="text-muted-foreground">Participantes</span>
        <span className="font-semibold text-green-600">{d.participantes.toLocaleString()}</span>
      </div>
      <div className="flex items-center justify-between gap-6">
        <span className="text-muted-foreground">Conversión</span>
        <span className="font-semibold text-blue-600">{d.conversion}%</span>
      </div>
    </div>
  )
}

interface ConversionChartProps {
  data: BreakdownGrupo[]
}

export function ConversionChart({ data }: ConversionChartProps) {
  const height = Math.max(data.length * 44, 120)
  return (
    <ChartContainer config={chartConfig} className="w-full" style={{ height: `${height}px` }}>
      <BarChart data={data} layout="vertical" barGap={2} barCategoryGap="22%" margin={{ right: 24, left: 8 }}>
        <CartesianGrid horizontal={false} />
        <XAxis type="number" tickLine={false} axisLine={false} />
        <YAxis
          type="category"
          dataKey="grupo"
          tickLine={false}
          axisLine={false}
          tick={{ fontSize: 12 }}
          width={140}
        />
        <ChartTooltip content={<ConversionTooltip />} />
        <Bar dataKey="registros" fill="var(--color-registros)" radius={[0, 4, 4, 0]} />
        <Bar dataKey="participantes" fill="var(--color-participantes)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ChartContainer>
  )
}
